<template>
  <div class="modal" :style="{ display: (openDialog ? 'flex' : 'none') }">
    <div class="dialogBox" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <div style="width: 100%; display: flex; justify-content: flex-end; flex-direction: row;">
        {{this.title}}
      </div>
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; white-space: pre-wrap;">
        {{this.text}}
      </div>
      <div style="display: flex; flex-direction: row; justify-content: center; align-items: start;">
        <div style="border: solid 1px #999999; margin: 4px; padding: 8px;" @click="close">OK</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: [
    'isOpen',
    'title',
    'text'
  ],
  data () {
    return {
      dialogOpen: false
    }
  },
  computed: {
    openDialog: {
      get () {
        return this.isOpen
      },
      set (value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  methods: {
    close () {
      this.openDialog = false
    }
  },
  watch: {
    isOpen: function (value) {
      if (value) {
      } else {
        this.$viewer.update()
      }
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  overflow-y: auto;
  display: none;
  opacity: 0.8;
  /*
  justify-content: center;
  align-items: center;
  */
  background-color: black;
  z-index: 9999;
}

.dialogBox {
  width: 100%;
  max-width: 480px;
  height: 200px;
  background-color: white;
  opacity: 1;
  z-index: 10000;
}

</style>
